/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Step_Indicator_DoneInputs */

const tr_geliver_step_indicator_done = /** @type {(inputs: Geliver_Step_Indicator_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamamlandı`)
};

const en_geliver_step_indicator_done = /** @type {(inputs: Geliver_Step_Indicator_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

const de_geliver_step_indicator_done = /** @type {(inputs: Geliver_Step_Indicator_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgeschlossen`)
};

const ru_geliver_step_indicator_done = /** @type {(inputs: Geliver_Step_Indicator_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выполнено`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Geliver_Step_Indicator_DoneInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_step_indicator_done = /** @type {((inputs?: Geliver_Step_Indicator_DoneInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Step_Indicator_DoneInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_step_indicator_done(inputs)
	if (locale === "de") return de_geliver_step_indicator_done(inputs)
	if (locale === "ru") return ru_geliver_step_indicator_done(inputs)
	return tr_geliver_step_indicator_done(inputs)
});